module.exports = __webpack_public_path__ + "static/media/prix.830bb5a6.png";